import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { api } from 'xadmin'
import { C } from 'xadmin-ui'
import { Popover, Tooltip } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { use } from 'xadmin';
import { valueFormat } from '../apps/datatag'

const toFixed = (Dight, How = 2) => {
  return _.isNumber(Dight) ? Math.round(Dight * Math.pow(10, How)) / Math.pow(10, How) : Dight
}

const WarningInfo = ({ item }) => {
  return <C is="WarningPopover" item={item} />
}

const GapTime = ({ seconds }) => {
  let text = ''
  let ss = seconds < 0 && seconds > -5 ? 0 : seconds
  let rt = ss
  if (rt > 24 * 3600) {
    text += `${Math.floor(rt / (24 * 3600))}天`
    rt = rt % (24 * 3600)
  }
  if (text != '' || rt > 3600) {
    text += ` ${Math.floor(rt / 3600)}小时`
    rt = rt % 3600
  }
  if (text != '' || rt > 60) {
    text += ` ${Math.floor(rt / 60)}分`
    rt = rt % 60
  }
  text += ` ${rt}秒`

  return <span><Tooltip title={`${ss}秒`}>{text}</Tooltip></span>
}

const showDataModalParams = {
  'timeRange': {
    'type': 'forward',
    'count': 1,
    'unit': 'h',
    'fromNow': true
  }
}

const queryLastData = (where, callback) => {
  const stringWhere = JSON.stringify(where)
  api({ name: 'core/data' })
    .fetch('/latest', {
      method: 'POST',
      body: stringWhere
    })
    .then(({ json, status }) => {
      if (json && !_.isEmpty(json) && status == 200) {
        const payload = {}
        json.forEach(item => {
          // 删除uid升级
          const id = item.id
          const time = moment(item.time).format('YYYY-MM-DD HH:mm:ss')
          if (!payload[id]) {
            payload[id] = { fields: { [item.tagId]: { time, value: item?.value } } }
          } else {
            payload[id] = { fields: { ...payload[id].fields, [item.tagId]: { time, value: item?.value } } }
          }
        })
        callback(payload)
      }
    }).catch(err => {
      console.log(err)
    })
}

const LatestValue = ({ node, tag, value }) => {
  const [state, setState] = React.useState(null)
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    const set = res => {
      const path = `${node?.id}.fields.${tag?.id}.value`
      const value = _.get(res, path)
      setState(value)
      setLoading(false)
    }
    setLoading(true)
    queryLastData([{ id: node?.id, tagId: tag?.id }], set)
  }, [])

  React.useEffect(() => {
    if (!_.isNil(value)) {
      setState(value)
    }
  }, [value])

  let val = state

  // 数据点配置时间戳时间格式
  if (tag?.timeFormat?.hasFormat && tag?.timeFormat?.format && val != undefined) {
    val = moment(val).format(tag?.timeFormat?.format)
  }

  if (tag.tagValue && tag.tagValue.enum && _.isArray(tag.tagValue.enum)) {
    tag.tagValue.enum.forEach(o => {
      if (o?.value == val || o?.value == val?.toString()) {
        val = o.label
      }
    })
  }

  //  小数位数数据转换
  if (tag?.fixed) {
    val = valueFormat(value, tag?.fixed, tag?.valFormat, tag?.polish)
  }

  return <p><strong>最新有效值: </strong>{loading ? <LoadingOutlined /> : !_.isNil(val) ? val : null}</p>
}

const DataTagPopover = ({ timeoutDisplay = false, value, tag, node, colors = {}, visible: initVisible, ValueComponent }) => {
  const [visible, setVisible] = React.useState(initVisible)
  const refRenderStr = React.useRef(null)
  const refTimer = React.useRef(null)
  const { time: now } = use('time')
  const currentTime = moment()
  const dataContext = use('data.context')

  const { warnings, dispatch } = use('redux', state => ({ warnings: state.warning ? state.warning.unread : null }))

  const onShow = async () => {
    setVisible(false)
    if (dataContext && !_.isEmpty(dataContext)) {
      const { setParams, showModal } = dataContext
      let newNode = _.cloneDeep(node)
      if (node?.id) newNode = await api({ name: 'core/node' }).get(`${node?.id} `).then(info => ({ id: node?.id, name: info.name }))
      setParams({
        ...showDataModalParams, tags: [{
          data: {
            name: `${newNode.name}.${tag.name}`,
            value: `${newNode.id}.${tag.id}`,
            origin: { ...tag, node: newNode }
          },
          fixed: 3
        }]
      })
      showModal(true)
    }
  }

  const findWarningState = React.useCallback((warnings, node, tag, normal) => {
    let state = 'normal', warning, color = normal || ''
    if (warnings && warnings.length) {
      warnings.sort((a, b) => {
        return Date.parse(b.time) - Date.parse(a.time) //时间正序
      })
      warning = _.find(warnings, w => !w.recoveryTime && w.node && w.node.id == node.id && w.fields && _.some(w.fields, f => f.id == tag.id))

      if (warning !== undefined) {
        if (_.isArray(warning.type)) {
          _.forEach(warning.type, item => {
            color = colors[item] || color
          })
        }
        if (warning.level == '高') {
          color = colors[warning.level] || colors?.warning3 || color || '#f00'
        } else if (warning.level == '中') {
          color = colors[warning.level] || colors?.warning2 || color || '#ff6347'
        } else {
          color = colors[warning.level] || colors?.warning1 || color || '#4c2f0a'
        }
        state = 'warning'
      }
    }
    return { state, color, warning }
  }, [])

  const sleepInterval = window._iot_dashboard_event_modal_sleepInterval
  const sleepTime = window._iot_dashboard_event_modal_sleepTime
  const update = window._iot_dashboard_event_modal
  const isForceStop = sleepInterval && sleepTime ? currentTime.unix() - sleepTime > sleepInterval : true

  const { color, warning, state } = findWarningState(warnings, node, tag, colors?.normal)

  const renderParams = _.toString([value, tag, visible, color, state, warning, dataContext, now.unix()])

  const previousTimer = refTimer.current
  const sameSecond = previousTimer == now.unix()

  const renderStr = sameSecond || update || !isForceStop ? refRenderStr.current : renderParams

  return React.useMemo(() => {

    refRenderStr.current = renderStr
    refTimer.current = now.unix()

    if (value && (!_.isNil(value?.value) || !_.isNil(value.time))) {
      // 毫秒为单位除以1000
      let time = moment(value.time)
      let val = (_.isNumber(value?.value) ?
        toFixed(value?.value, tag && tag.fixed !== undefined ? tag.fixed : 3) :
        value?.value ? value?.value?.toString() : <span className="text-muted">-</span>
      )
      let noData = false
      let backgroundColor = colors?.bg?.[0] || ''
      let opacity = 1

      const gap = value.gap != undefined ? value.gap : (now.unix() - time.unix())

      if (tag.timeout) {
        if (gap > tag.timeout) { noData = true }
        if (gap > tag.timeout * 8) { opacity = 0.7, backgroundColor = colors?.timeout || 'rgba(0,0,0,0)' }
        if (gap > tag.timeout * 3) { opacity = 0.8, backgroundColor = colors?.offline || 'rgba(0,0,0,0)' }
      }
      if (tag.tagValue && tag.tagValue.enum && _.isArray(tag.tagValue.enum)) {
        tag.tagValue.enum.forEach(o => {
          if (o?.value == val || o?.value == val.toString()) {
            val = o.label
          }
        })
      }
      // console.log(value)
      return (
        <Popover title={tag.name} trigger="click" id="data-item-popover"
          visible={visible} onVisibleChange={setVisible} content={(
            <>
              <LatestValue node={node} tag={tag} value={value?.value} />
              <p><strong>最新时间: </strong>{moment(time).format('YYYY-MM-DD HH:mm:ss')}</p>
              <p><strong>距现时间: </strong><GapTime seconds={gap} /></p>
              {tag.interval ? <p><strong>采集周期: </strong>{tag.interval}秒</p> : null}
              {warning ? <WarningInfo item={warning} /> : null}
              {dataContext && !_.isEmpty(dataContext) && !_.isString(value?.originValue) ? <p style={{ textAlign: 'center' }}><a onClick={onShow}>查看历史数据</a></p> : null}
            </>
          )}>
          <span className={state} style={{ cursor: 'pointer', color, opacity, backgroundColor, userSelect: 'none' }} >
            {timeoutDisplay && tag.errview == '不显示当前值' && noData ? <span className="text-muted">-</span> : ValueComponent ? <ValueComponent value={val} tag={tag} /> : val}
          </span>
        </Popover>
      )
    } else {
      return <span className="text-muted">-</span>
    }
  }, [renderStr, renderParams])
}

export default DataTagPopover
